require('./brokerConvenienceMiFIDTestStepOmittedTest.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKInput } = require('commonsComponents/OKInput');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @actions
const BrokerConvenienceMiFIDTestStepOmitTestAction = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepOmitTest');

// @constants
const CLASS_NAME = 'broker-convenience-mifid-test-step-omitted-test';

class BrokerConvenienceMiFIDTestStepOmittedTest extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnTranscriptionChange = this.handleOnTranscriptionChange.bind(this);
        this.handleContinueClick = this.handleContinueClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.immBrokerConvenienceMiFIDTest.get('omitTestCanContinue')) {
            nextProps.onContinueOperation();
        }
    }

    buildButtons() {
        const { onCancel } = this.props;

        return (
            <footer className={`${CLASS_NAME}__footer text-right`}>
                <div className="pull-left">
                    <OKButton modifier="link-ghost" onClick={onCancel}>
                        <FormattedText value="broker-convenienceMifidTestCancel"/>
                    </OKButton>
                </div>
                <OKButton onClick={this.handleContinueClick} modifier="secondary">
                    <FormattedText value="broker-convenienceMifidOmitTestContinue"/>
                </OKButton>
            </footer>
        );
    }

    buildFinished(){
        const { clientEmail, disclaimerText, resultText } = this.props;
        const transcriptContent = this.buildTranscriptContent();
        const buttons = this.buildButtons();
 
        return (
            <ContentBox
                title={formatText('broker-convenienceMifidTestOperateFinishingTest')}
                titleSeparator={true}
            >
                <div className={`${CLASS_NAME}__info`}>
                    <p>
                        <h2 className={`${CLASS_NAME}__subtitle`}>
                            <FormattedText value="consultMiFID-subtitle"/>
                        </h2>
                        <FormattedText className={`${CLASS_NAME}__info`}
                            value="broker-convenienceMifidTestAnswersSentToEmail"
                            injectedStrings={[clientEmail]}
                        />
                        <div>
                            <h4 className={`${CLASS_NAME}__result-title`}>
                                <FormattedText value="consultMiFID-evaluationResult" format="uppercase" />
                            </h4>
                            <p className={`${CLASS_NAME}__info-bold`}>
                                {resultText}
                            </p>
                        </div>
                    </p>
                </div>
                <div className={`${CLASS_NAME}__disclaimer-message`}>
                    <OKMessage type="informative">
                        {disclaimerText}
                    </OKMessage>
                </div>
                {transcriptContent}
                {buttons}
            </ContentBox>
        );
    }

    buildTranscriptContent() {
        const { immBrokerConvenienceMiFIDTest, repeatSentenceText } = this.props;
        const formattedRepeatSentence = repeatSentenceText.split('<br><br>'); // @hardcoded
        const transcription = immBrokerConvenienceMiFIDTest.get('omitTestTrascriptionText');
        const omitTestInvalidText = immBrokerConvenienceMiFIDTest.get('omitTestInvalidText');
        const formattedPartInfo = formattedRepeatSentence[0];
        const formattedPartSubInfo = formattedRepeatSentence[1] ? formattedRepeatSentence[1] : '';

        return (
            <div>
                <div className={`${CLASS_NAME}__info1`}>{formattedPartInfo}</div>
                <div className={`${CLASS_NAME}__info2`}>{formattedPartSubInfo}</div>
                <p> <FormattedText value="broker-convenienceMifidTestTranscription"/> </p>
                <div className={`${CLASS_NAME}__field`}>
                    <OKInput
                        value={transcription}
                        onChange={this.handleOnTranscriptionChange}
                        errorState={omitTestInvalidText}
                        errorMessage={formatText('broker-convenienceMifidTestTranscriptionError')}
                    />
                </div>
            </div>
        );
    }

    buldOmit(){
        const { disclaimerText } = this.props;
        const warningDisclaimerText = formatText('broker-convenienceMifidTestWarningDisclaimerText');
        const transcriptContent = this.buildTranscriptContent();
        const buttons = this.buildButtons();

        return (
            <ContentBox
                title={formatText('broker-convenienceMifidTestOperateOmittingTest')}
                titleSeparator={true}>
                <div className={`${CLASS_NAME}__disclaimer-message`}>
                    <OKMessage type="informative">
                        {warningDisclaimerText}
                        {disclaimerText}
                    </OKMessage>
                </div>
                {transcriptContent}
                {buttons}
            </ContentBox>
        );
    }

    handleContinueClick() {
        this.props.onValidateTranscription();
    }

    handleOnTranscriptionChange(event) {
        const transcription = event.target.value;
        this.props.onChangeTranscription(transcription);
    }

    render() {
        const { isTestOmitted } = this.props;
        const content = isTestOmitted ? this.buldOmit() : this.buildFinished();

        return (
            <div>
                {content}
            </div>
        );
    }
}

BrokerConvenienceMiFIDTestStepOmittedTest.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    onGoToMakeTest: PropTypes.func.isRequired,
    onChangeTranscription: PropTypes.func.isRequired,
    onContinueOperation: PropTypes.func.isRequired,
    onValidateTranscription: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    repeatSentenceText: PropTypes.string.isRequired,
    isTestOmitted: PropTypes.bool.isRequired,
    resultText: PropTypes.string.isRequired,
    clientEmail: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired
};

module.exports.constructor = BrokerConvenienceMiFIDTestStepOmittedTest;
module.exports.BrokerConvenienceMiFIDTestStepOmittedTest = connect(state => ({
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest
}), {
    onValidateTranscription: BrokerConvenienceMiFIDTestStepOmitTestAction.validateTranscription,
    onGoToMakeTest: BrokerConvenienceMiFIDTestStepOmitTestAction.goToMakeTest,
    onChangeTranscription: BrokerConvenienceMiFIDTestStepOmitTestAction.changeTranscription
})(BrokerConvenienceMiFIDTestStepOmittedTest);